import { AccountSettingsService } from '@techrules/portallib';
import { CommonService } from '@tech-services/common.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormatsService } from '@techrules/pipelib';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, catchError, map, takeUntil, throwError } from 'rxjs';
import { SessionService } from '@tech-services/session.service';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { TechDialogsService } from '../../../shared/tech-dialogs.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { TechModalDialogResendModel } from '../../../shared/techmodaldialogresend/techmodaldialogresend.model';
import { TechModalDialogComponent } from '../../../shared/techmodaldialog/techmodaldialog.component';

@Component({
  selector: 'tech-mainsettings',
  templateUrl: './mainsettings.component.html',
  styleUrls: ['./mainsettings.component.scss'],
})
export class MainsettingsComponent implements OnInit {
  public form: FormGroup = this.fb.group({});
  public updateDisabled: boolean = true;
  public languages = [];
  public languageDefault = localStorage.getItem('Language');
  public onboardingOptions = [
    {
      id: 'Linear',
      text: 'k003447', //Token: Linear
    },
    {
      id: 'Non-Linear',
      text: 'k003448', //Token: Non-linear
    },
  ];
  public onboardingOptionsDefault = localStorage.getItem('OnboardingType');
  public allowOpenNewAccountOptions = [
    {
      id: 'true',
      text: 'k000192', //Yes
    },
    {
      id: 'false',
      text: 'k000193', //No
    },
  ];
  public allowOpenNewAccountDefault = localStorage.getItem(
    'AllowOpenNewAccount'
  );
  public smsVerificationOptions = [
    {
      id: 'true',
      text: 'k000192', //Yes
    },
    {
      id: 'false',
      text: 'k000193', //No
    },
  ];
  public smsVerificationDefault = localStorage.getItem('SmsVerification');
  public themesImg;
  public themeImgDefault = localStorage.getItem('ThemeImg');
  public themesCss;
  public themeCssDefault = localStorage.getItem('ThemeCss');
  private unsubscribe$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private accountService: AccountSettingsService,
    private commonService: CommonService,
    private dialogService: TechDialogsService,
    protected sessionService: SessionService,
    private formatsService: FormatsService,
    public dialog: MatDialog,
    private httpBackend: HttpBackend,
    private http: HttpClient
  ) {
    this.newform();
  }

  ngOnInit(): void {
    this.getThemes()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.themesCss = data;
        this.themesImg = data;
      });
    this.commonService.showMenuSource.next(false);
    this.getBussinessArea();
    this.translate.get('k001196').subscribe((text: string) => {
      this.commonService.setTitle(text + ' | ' + AppConfig.settings.tabTitle);
    });
  }

  private getBussinessArea() {
    this.accountService.getBusinessArea().subscribe(
      (data) => {
        this.languages = data.DomainLanguages;
      },
      (err) => {
        this.commonService.errorManager('apirest_getBussinessArea', err);
        return throwError(err);
      }
    );
  }

  public newform() {
    this.form = this.fb.group({
      language: [this.languageDefault, []],
      themeImg: [this.themeImgDefault, []],
      themeCSS: [this.themeCssDefault, []],
      onboardingType: [this.onboardingOptionsDefault, []],
      allowOpenNewAccount: [this.allowOpenNewAccountDefault, []],
      smsVerification: [this.smsVerificationDefault, []],
    });
  }

  public change(event) {
    this.updateDisabled = false;
  }

  public reset() {
    localStorage.setItem('Language', AppConfig.settings.language);
    this.translate.use(AppConfig.settings.language);
    this.sessionService.language = AppConfig.settings.language;
    this.formatsService.locale = AppConfig.settings.language;
    localStorage.setItem('ThemeImg', AppConfig.settings.customTheme);
    var customThemeFile = AppConfig.settings.customThemeFile.replace(
      '.json',
      ''
    );
    localStorage.setItem('ThemeCss', customThemeFile);
    localStorage.setItem('OnboardingType', this.form.value.onboardingType);
    localStorage.setItem(
      'AllowOpenNewAccount',
      AppConfig.settings.allowOpenNewAccount.toString()
    );
    localStorage.setItem('SmsVerification', AppConfig.settings.SMSVerification);
    localStorage.removeItem('MainSettings');
    let dialogData = new TechModalDialogResendModel();
    let dialogRef: any;
    this.translate.get('k003459').subscribe((text) => {
      dialogData.title = text; //Token: Confirmed reset
    });
    this.translate.get('k003460').subscribe((text) => {
      dialogData.content = text; //Token: The initial configuration has been reset by business area listed in the <i>appsettings</i>
    });
    dialogRef = this.dialog.open(TechModalDialogComponent, {
      panelClass: this.commonService.panelClassGeneral,
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      window.location.reload();
    });
  }

  public update() {
    localStorage.setItem('Language', this.form.value.language);
    this.translate.use(this.form.value.language);
    this.sessionService.language = this.form.value.language;
    this.formatsService.locale = this.form.value.language;
    localStorage.setItem('ThemeImg', this.form.value.themeImg);
    localStorage.setItem('ThemeCss', this.form.value.themeCSS);
    localStorage.setItem('OnboardingType', this.form.value.onboardingType);
    localStorage.setItem(
      'AllowOpenNewAccount',
      this.form.value.allowOpenNewAccount
    );
    localStorage.setItem('SmsVerification', this.form.value.smsVerification);
    localStorage.setItem('MainSettings', 'true');
    let dialogData = new TechModalDialogResendModel();
    let dialogRef: any;
    this.translate.get('k003457').subscribe((text) => {
      dialogData.title = text; //Token: Confirmed settings
    });
    this.translate.get('k003458').subscribe((text) => {
      dialogData.content = text; //Token: The new configuration has been successfully implemented
    });
    dialogRef = this.dialog.open(TechModalDialogComponent, {
      panelClass: this.commonService.panelClassGeneral,
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      window.location.reload();
    });
  }

  public getThemes(): any {
    return this.http.get<any>('./assets/themes/comboThemes.json').pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.dialogService.openErrorDialog(err); //Token: Error en
        return throwError(err);
      })
    );
  }
}
